import { filter } from 'rxjs/operators';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { BrandingState } from '../../branding/store/branding.state';
import { BrandingService } from '../../branding/providers/branding.service';

@Component({
    selector: 'app-data-security',
    templateUrl: './data-security.component.html',
    styleUrls: ['./data-security.component.scss']
})
export class DataSecurityComponent {
    public brandingData$: Observable<BrandingState>;

    constructor(private brandingService: BrandingService) {
        this.brandingData$ =
            this.brandingService.getBrandingSettingsFromStore().pipe(filter(e => e !== null && e !== undefined));
    }
}
